import {Component, Input, model, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import Tokenizer from 'fluidpay-tokenizer';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbDateStructAdapter, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../services/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StateDto } from '../../../dtos/StateDto';

@Component({
    selector: 'app-card-form',
    templateUrl: './card-form.component.html',
    styleUrl: './card-form.component.scss',
    standalone: false,
  host: {
    class: 'row flex-grow-1'
  }
})
export class CardFormComponent implements OnInit {
  constructor(
    private toastService: ToastService,
    private spinner: NgxSpinnerService
  ) {}

  @Input() price: number;
  today = new Date();
  // TODO: move these to env
  cardDisabled = false;
  selectedStateCode = '';
  cardForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    dateOfBirth: new FormControl(new NgbDate(1, 1, 1969), Validators.required),
    addressLine1: new FormControl('', Validators.required),
    addressLine2: new FormControl(''),
    city: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    zip: new FormControl('', Validators.required),
    email: new FormControl('', Validators.required),
    phoneNumber: new FormControl('', Validators.required),
  });
  
  maxDate: NgbDateStruct = { year: this.today.getFullYear()-21, month: this.today.getMonth()+1, day: this.today.getDate() }
  minDate: NgbDateStruct = { year: this.today.getFullYear()-121, month: this.today.getMonth()+1, day: this.today.getDate() }
  

  courseId = model();
  tokenizer: Tokenizer;
  states: StateDto[] = [
  {
    "name": "Alabama",
    "code": "AL"
  },
  {
    "name": "Alaska",
    "code": "AK"
  },
  {
    "name": "Arizona",
    "code": "AZ"
  },
  {
    "name": "Arkansas",
    "code": "AR"
  },
  {
    "name": "California",
    "code": "CA"
  },
  {
    "name": "Colorado",
    "code": "CO"
  },
  {
    "name": "Connecticut",
    "code": "CT"
  },
  {
    "name": "Delaware",
    "code": "DE"
  },
  {
    "name": "Florida",
    "code": "FL"
  },
  {
    "name": "Georgia",
    "code": "GA"
  },
  {
    "name": "Hawaii",
    "code": "HI"
  },
  {
    "name": "Idaho",
    "code": "ID"
  },
  {
    "name": "Illinois",
    "code": "IL"
  },
  {
    "name": "Indiana",
    "code": "IN"
  },
  {
    "name": "Iowa",
    "code": "IA"
  },
  {
    "name": "Kansas",
    "code": "KS"
  },
  {
    "name": "Kentucky",
    "code": "KY"
  },
  {
    "name": "Louisiana",
    "code": "LA"
  },
  {
    "name": "Maine",
    "code": "ME"
  },
  {
    "name": "Maryland",
    "code": "MD"
  },
  {
    "name": "Massachusetts",
    "code": "MA"
  },
  {
    "name": "Michigan",
    "code": "MI"
  },
  {
    "name": "Minnesota",
    "code": "MN"
  },
  {
    "name": "Mississippi",
    "code": "MS"
  },
  {
    "name": "Missouri",
    "code": "MO"
  },
  {
    "name": "Montana",
    "code": "MT"
  },
  {
    "name": "Nebraska",
    "code": "NE"
  },
  {
    "name": "Nevada",
    "code": "NV"
  },
  {
    "name": "New Hampshire",
    "code": "NH"
  },
  {
    "name": "New Jersey",
    "code": "NJ"
  },
  {
    "name": "New Mexico",
    "code": "NM"
  },
  {
    "name": "New York",
    "code": "NY"
  },
  {
    "name": "North Carolina",
    "code": "NC"
  },
  {
    "name": "North Dakota",
    "code": "ND"
  },
  {
    "name": "Ohio",
    "code": "OH"
  },
  {
    "name": "Oklahoma",
    "code": "OK"
  },
  {
    "name": "Oregon",
    "code": "OR"
  },
  {
    "name": "Pennsylvania",
    "code": "PA"
  },
  {
    "name": "Rhode Island",
    "code": "RI"
  },
  {
    "name": "South Carolina",
    "code": "SC"
  },
  {
    "name": "South Dakota",
    "code": "SD"
  },
  {
    "name": "Tennessee",
    "code": "TN"
  },
  {
    "name": "Texas",
    "code": "TX"
  },
  {
    "name": "Utah",
    "code": "UT"
  },
  {
    "name": "Vermont",
    "code": "VT"
  },
  {
    "name": "Virginia",
    "code": "VA"
  },
  {
    "name": "Washington",
    "code": "WA"
  },
  {
    "name": "West Virginia",
    "code": "WV"
  },
  {
    "name": "Wisconsin",
    "code": "WI"
  },
  {
    "name": "Wyoming",
    "code": "WY"
  }
]

  async ngOnInit(){    
    this.tokenizer = new Tokenizer({
      // Your public API key (from Control Panel → Settings → API Keys)
      apikey: environment.fluidPayKey,
      url: environment.fluidPayUrl,

      // CSS selector where the iframe will be injected
      container: '#payment-form',

      settings: {
        payment: {
          types: ['card'],  // Enable both card and ACH
          card: {
            requireCVV: true,
          }
        },
      },

      // Callback when tokenizer.submit() completes
      submission: (resp) => {

        // Token generated successfully
        if (resp.status === 'success') {
          this.createPayment(resp.token)
        }

        // Form validation failed (empty or invalid fields)
        else if (resp.status === 'validation') {
          console.log('Invalid fields:', resp.invalid)
        }

        // Error occurred (network, invalid API key, etc.)
        else {
          console.log('Error:', resp.msg)
        }
      }
    })
  }

  showSuccessToast() {
    this.toastService.show('Check your email inbox for confirmation.', { header: 'Registration Succeeded', classname: 'bg-success text-light' });
  }
  showFailureToast() {
    this.toastService.show('Please message us for support.', { header: 'Registration Failed', classname: 'bg-danger text-light' });
  }

  async createPayment(tokenObj: any) {
    const body = JSON.stringify({
      sourceId: tokenObj,
      idempotencyKey: window.crypto.randomUUID(),
      billingContact: {
        givenName : this.cardForm.get('firstName')?.value,
        familyName : this.cardForm.get('lastName')?.value,
        email : this.cardForm.get('email')?.value,
        phone : this.cardForm.get('phoneNumber')?.value,
        address : this.cardForm.get('addressLine1')?.value,
        city : this.cardForm.get('city')?.value,
        state : this.selectedStateCode,
        zip : this.cardForm.get('zip')?.value,
      },
      courseId: this.courseId(),
      price: this.price,
    });

    this.spinner.show();

    await fetch(`${environment.apiUrl}/courses/create-payment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    }).then(data => {
      if (data.ok) {
        this.showSuccessToast();
        this.cardForm.reset();
      } else {
        this.showFailureToast();
      }
      this.spinner.hide();
    });
  }

  selectState(selectedState: StateDto) {
    this.selectedStateCode = selectedState.code;
    this.cardForm.get('state')?.setValue(selectedState.name);
  }
}
